export const FIREBASE_API_KEY = 'AIzaSyBw2aR-rx62HS8MV02EVSqmV31A2sv4_OE';
export const FIREBASE_AUTH_DOMAIN = 'padel-ab4bc.firebaseapp.com';
export const FIREBASE_DATABASE_URL = 'https://padel-ab4bc.firebaseio.com';
export const FIREBASE_PROJECT_ID = 'padel-ab4bc';
export const FIREBASE_STORAGE_BUCKET = 'padel-ab4bc.appspot.com';
export const FIREBASE_MESSAGING_SENDER_ID = '951067512844';

// export const META_DOC = "RmrEqhJ0czpLQl1DT7hq";
